import React from 'react';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import {
  AddButton,
  AppContent,
  ButtonGroup,
  Icon,
  LoadingState,
  SecondaryButton,
  Link,
} from '@common/components';
import { Col, Row } from 'antd';
import { SuppliersManagementList } from './suppliers-management';
import { ORGANIZATION_ADMIN_MENU } from 'works/legacy/pages/organization/admin-settings/organization-admin-vertical-nav-menu';
import { useCurrentMembership } from '@identity/hooks';
import { buildDialogUrl } from '@common/services';

export function AdminSuppliersManagementPage() {
  useSetBreadcrumbs([
    {
      name: 'Admin',
      path: '/works/admin',
    },
    {
      name: ORGANIZATION_ADMIN_MENU.SUPPLIERS.LABEL,
      path: ORGANIZATION_ADMIN_MENU.SUPPLIERS.ROUTE,
    },
  ]);

  const currentMembership = useCurrentMembership();

  if (!currentMembership) {
    return (
      <AppContent>
        <LoadingState />
      </AppContent>
    );
  }

  const canShowTiering = currentMembership.canShowTiering ?? false;

  return (
    <>
      <AppContent className="admin-supplier-page">
        <Row justify="end" style={{ paddingBottom: '12px' }}>
          <Col>
            <ButtonGroup>
              {canShowTiering && (
                <Link to={buildDialogUrl('supplier-management-tiers-drawer')}>
                  <SecondaryButton icon={<Icon icon="chartPyramid" />}>
                    Tiers
                  </SecondaryButton>
                </Link>
              )}
              <Link
                to={`${ORGANIZATION_ADMIN_MENU.SUPPLIERS.ROUTE}/bulk-locations-update`}
              >
                <AddButton>Locations</AddButton>
              </Link>
              <Link
                to={`${ORGANIZATION_ADMIN_MENU.SUPPLIERS.ROUTE}/invitation`}
              >
                <SecondaryButton icon={<Icon icon="envelope" />}>
                  Invite Suppliers
                </SecondaryButton>
              </Link>
            </ButtonGroup>
          </Col>
        </Row>
        <SuppliersManagementList />
      </AppContent>
    </>
  );
}
